import { useHideMetricMutation } from 'models';
import { useIsMetricHidden } from '../Report.hooks';
import { CompletionStatus } from '../ReportUtils';
import { DataCollectionLevel } from '../../DataCollection/DataCollection.d';
import { MetricViewEnums } from '../../DisclosureRequirements';
import { useParams } from 'react-router-dom';
import { useCurrentCompany } from 'utils/hooks';

export const useReportCardSourceLink = ({
  dataCollection,
  standardRef,
  drRef,
  metricRef,
  reportingUnitId,
}: {
  dataCollection: DataCollectionLevel;
  standardRef: string;
  drRef: string;
  metricRef: string;
  reportingUnitId?: string;
}) => {
  const { esrsAssessmentId = '', framework = '' } = useParams();
  const { company } = useCurrentCompany();
  const companyId = company?.id ?? '';

  return dataCollection === DataCollectionLevel.reportingUnits
    ? `/${companyId}/sustainability-reporting/${framework}/${esrsAssessmentId}/bu-standard/${standardRef}/bu/${reportingUnitId}/disclosure-requirement/${drRef}/${MetricViewEnums.dataInput}?metricRef=${metricRef}`
    : `/${companyId}/sustainability-reporting/${framework}/${esrsAssessmentId}/standard/${standardRef}/disclosure-requirement/metric/${drRef}/${MetricViewEnums.dataInput}?metricRef=${metricRef}`;
};

// Used for DRs and Metrics
export const getReportCardStatus = ({
  isHidden,
  isCompleted,
}: {
  isHidden: boolean;
  isCompleted: boolean;
}) => {
  if (isHidden) {
    return CompletionStatus.hidden;
  }
  if (isCompleted) {
    return CompletionStatus.complete;
  }
  return CompletionStatus.incomplete;
};

export const useCardVisibility = ({ metricRef }: { metricRef: string }) => {
  const { esrsAssessmentId = '' } = useParams();
  const { isHidden, loading: loadingMetricVisibility } = useIsMetricHidden(
    metricRef,
    esrsAssessmentId
  );

  const [onHideMetric, { loading: isHidingMetric }] = useHideMetricMutation();

  const toggleHidden = () => {
    onHideMetric({
      variables: {
        metricRef: metricRef,
        isHidden: !isHidden,
        assessmentId: esrsAssessmentId,
      },
    });
  };

  return {
    isHidden,
    loadingMetricVisibility,
    isHidingMetric,
    toggleHidden,
  };
};
